import React from 'react';
import PropTypes from 'prop-types';

export const TblRowTail = ({ children, buttonChildren, unUsedInputBox, formClass, guideText }) => {
  return (
    <div className="form-field">
      <div className={`form-field-box ${formClass}`}>
        {unUsedInputBox ? <>{children}</> : <div className="input-group-box">{children}</div>}
        {buttonChildren}
      </div>
      {guideText}
    </div>
  );
};
TblRowTail.propTypes = {
  children: PropTypes.node,
  buttonChildren: PropTypes.node,
  unUsedInputBox: PropTypes.bool,
  formClass: PropTypes.string,
  guideText: PropTypes.node,
};
TblRowTail.defaultProps = {
  children: <></>,
  buttonChildren: <></>,
  unUsedInputBox: false,
  formClass: '',
  guideText: <></>,
};
export default TblRowTail;
